module.exports = __webpack_public_path__ + "img/ir_remote.852d9898.png";